import { render, staticRenderFns } from "./MappedClassTable.vue?vue&type=template&id=545e842e"
import script from "./MappedClassTable.vue?vue&type=script&lang=js"
export * from "./MappedClassTable.vue?vue&type=script&lang=js"
import style0 from "./MappedClassTable.vue?vue&type=style&index=0&id=545e842e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports